import React from 'react';
import { Redirect } from 'react-router-dom';
// import NotFoundError from '../components/layouts/ErrorPages/NotFoundError';

const NotFoundErrorPage = () => {
  return <Redirect to="/" />;
};

export default NotFoundErrorPage;
